// ALL METHODS RELATED TO THE TEMPLATES FEATURE ARE STORED HERE

// This methods sets the sender data as the variable values in post view
export function setSender(post, owner){
    const regex = /{{sender\.((?:.*?))}}/g
    const senderVariables = post.safe_content.match(regex);
    const titleVariables = post.title.match(regex);

    // for content
    if (senderVariables) {
        const extract = senderVariables.map(variable => {
          const match = variable.match(/{{sender\.((?:.*?))}}/);
          if (match && match.length >= 2) {
              return match[1];
          }
          return '';
      });
        extract.map(variable => {
          while(post.safe_content.includes(`{{sender.${variable}}}`)) {
            let value = ''
            if (owner[variable]) {
              // using basic fields
              value = owner[variable]
            } else {
              // using custom fields
              let usedVariable = variable
              while(usedVariable.includes('_')) {
                usedVariable = usedVariable.replace('_',' ')
              }
              let fieldId;
              let customField;
              owner.team_custom_fields.map(field => {
                if (field.name.toLowerCase() === usedVariable.toLowerCase()) {
                  fieldId = field.id
                  customField = field
                }
              })
              owner.custom_field_values.map(field => {
                if (field.team_custom_field_id === fieldId && customField.value_type !== 'link') {
                  value = field.value
                }
  
                if (customField.value_type == 'link' && field.team_custom_field_id === fieldId) {
                  value = `<a href="${field.value ? field.value : '#'}" target='_blank'>${customField.anchor_text ? customField.anchor_text : customField.name}</a>`
                }
              })
            }
            post.safe_content = post.safe_content.replace(`{{sender.${variable}}}`, value)
          }
        })
    }

    // for title
    if (titleVariables) {
      const titleExtract = titleVariables.map(variable => {
        const match = variable.match(/{{sender\.((?:.*?))}}/);
        if (match && match.length >= 2) {
            return match[1];
        }
        return '';
    });
      titleExtract.map(variable => {
        while(post.title.includes(`{{sender.${variable}}}`)) {
          let value = ''
          if (owner[variable]) {
            // using basic fields
            value = owner[variable]
          } else {
            // using custom fields
            let usedVariable = variable
            while(usedVariable.includes('_')) {
              usedVariable = usedVariable.replace('_',' ')
            }
            let fieldId;
            let customField;
            owner.team_custom_fields.map(field => {
              if (field.name.toLowerCase() === usedVariable.toLowerCase()) {
                fieldId = field.id
                customField = field
              }
            })
            owner.custom_field_values.map(field => {
              if (field.team_custom_field_id === fieldId && customField.value_type !== 'link') {
                value = field.value
              }

              if (customField.value_type == 'link' && field.team_custom_field_id === fieldId) {
                value = `<a href="${field.value ? field.value : '#'}" target='_blank'>${customField.anchor_text ? customField.anchor_text : customField.name}</a>`
              }
            })
          }
          post.title = post.title.replace(`{{sender.${variable}}}`, value)
        }
      })
  }
  }


//   This method sets the receiver data as variable value in post view/render
  export function setReceiver(post, owner){
    const regex = /{{receiver\.((?:.*?))}}/g
    const receiverVariables = post.safe_content.match(regex);
    const titleVariables = post.title.match(regex)

    // for content
    if (receiverVariables) {
        const extract = receiverVariables.map(variable => {
          const match = variable.match(/{{receiver\.((?:.*?))}}/);
          if (match && match.length >= 2) {
              return match[1];
          }
          return '';
      });
        extract.map(variable => {
          while(post.safe_content.includes(`{{receiver.${variable}}}`)) {
            let value = ''
            if (owner[variable]) {
              // using basic fields
              value = owner[variable]
            } else {
              // using custom fields
              let usedVariable = variable
              while(usedVariable.includes('_')) {
                usedVariable = usedVariable.replace('_',' ')
              }
              let fieldId;
              let customField;
              owner.team_custom_fields.map(field => {
                if (field.name.toLowerCase() === usedVariable.toLowerCase()) {
                  fieldId = field.id
                  customField = field
                }
              })
              owner.custom_field_values.map(field => {
                if (field.team_custom_field_id === fieldId && customField.value_type !== 'link') {
                  value = field.value
                }
  
                if (customField.value_type == 'link' && field.team_custom_field_id === fieldId) {
                  value = `<a href="${field.value ? field.value : '#'}" target='_blank'>${customField.anchor_text ? customField.anchor_text : customField.name}</a>`
                }
              })
            }
            post.safe_content = post.safe_content.replace(`{{receiver.${variable}}}`, value)
          }
        })
    }

    if (titleVariables) {
      const titleExtract = titleVariables.map(variable => {
        const match = variable.match(/{{receiver\.((?:.*?))}}/);
        if (match && match.length >= 2) {
            return match[1];
        }
        return '';
      });
      titleExtract.map(variable => {
        while(post.title.includes(`{{receiver.${variable}}}`)) {
          let value = ''
          if (owner[variable]) {
            // using basic fields
            value = owner[variable]
          } else {
            // using custom fields
            let usedVariable = variable
            while(usedVariable.includes('_')) {
              usedVariable = usedVariable.replace('_',' ')
            }
            let fieldId;
            let customField;
            owner.team_custom_fields.map(field => {
              if (field.name.toLowerCase() === usedVariable.toLowerCase()) {
                fieldId = field.id
                customField = field
              }
            })
            owner.custom_field_values.map(field => {
              if (field.team_custom_field_id === fieldId && customField.value_type !== 'link') {
                value = field.value
              }

              if (customField.value_type == 'link' && field.team_custom_field_id === fieldId) {
                value = `<a href="${field.value ? field.value : '#'}" target='_blank'>${customField.anchor_text ? customField.anchor_text : customField.name}</a>`
              }
            })
          }
          post.title = post.title.replace(`{{receiver.${variable}}}`, value)
        }
      })
  }
  }

//   This method sets organization value as variable value in post render/view
        export function setOrg(post, team){
            return post.safe_content.replace(/{{organization.name}}/g, team.name)
        }

        // This method sets the owner of the post
        export function findOwner(post, users){
            for (let x = 0; x < users.length; x++) {
              if (users[x].id == post.user_id) {
                return users[x]
              }
            }
          }


          export const fillProjectsData = (post) => {
            // No need to worry how long it will take this code to run, each variable will be used twice max and not all will run
            // for a post, speed is not affected
            while (post.title.includes('{{sender.name}}')) {
              post.title = post.title.replace('{{sender.name}}', post.project.name)
            }

            while (post.title.includes('{{sender.manager_name}}')) {
              if (post.project.manager){
                post.title = post.title.replace('{{sender.manager_name}}', `${post.project.manager.first_name} ${post.project.manager.last_name}`)
              } else {
                post.title = post.title.replace('{{sender.manager_name}}', '')
              }
            }

            while (post.title.includes('{{sender.manager_email}}')) {
              if (post.project.manager){
                post.title = post.title.replace('{{sender.manager_email}}', post.project.manager.email)
              } else {
                post.title = post.title.replace('{{sender.manager_email}}', '')
              }
            }

            while (post.title.includes('{{sender.coordinator_name}}')) {
              if (post.project.coordinator) {
                post.title = post.title.replace('{{sender.coordinator_name}}', `${post.project.coordinator.first_name} ${post.project.coordinator.last_name}`)
              } else {
                post.title = post.title.replace('{{sender.coordinator_name}}', '')
              }
            }

            while (post.title.includes('{{sender.coordinator_email}}')) {
              if (post.project.coordinator) {
                post.title = post.title.replace('{{sender.coordinator_email}}', post.project.coordinator.email)
              } else {
                post.title = post.title.replace('{{sender.coordinator_email}}', '')
              }
            }

            while (post.content.includes('{{sender.name}}')) {
              post.content = post.content.replace('{{sender.name}}', post.project.name)
            }

            while (post.content.includes('{{sender.manager_name}}')) {
              if (post.project.manager) {
                post.content = post.content.replace('{{sender.manager_name}}', `${post.project.manager.first_name} ${post.project.manager.last_name}`)
              } else {
                post.content = post.content.replace('{{sender.manager_name}}', '')
              }
            }

            while (post.content.includes('{{sender.manager_email}}')) {
              if (post.project.manager) {
                post.content = post.content.replace('{{sender.manager_email}}', post.project.manager.email)
              } else {
                post.content = post.content.replace('{{sender.manager_email}}', '')
              }
            }

            while (post.content.includes('{{sender.coordinator_name}}')) {
              if (post.project.coordinator) {
                post.content = post.content.replace('{{sender.coordinator_name}}', `${post.project.coordinator.first_name} ${post.project.coordinator.last_name}`)
              } else {
                post.content = post.content.replace('{{sender.coordinator_name}}', '')
              }
            }

            while (post.content.includes('{{sender.coordinator_email}}')) {
              if (post.project.coordinator) {
                post.content = post.content.replace('{{sender.coordinator_email}}', post.project.coordinator.email)
              } else {
                post.content = post.content.replace('{{sender.coordinator_email}}', '')
              }
            }
          }

          export const fillProjectsDataContent = (post) => {
            // No need to worry how long it will take this code to run, each variable will be used twice max and not all will run
            // for a post, speed is not affected
            let content = post.safe_content

            while (content.includes('{{sender.name}}')) {
              content = content.replace('{{sender.name}}', post.project.name)
            }

            while (content.includes('{{sender.manager_name}}')) {
              if (post.project.manager) {
                content = content.replace('{{sender.manager_name}}', `${post.project.manager.first_name} ${post.project.manager.last_name}`)
              } else {
                content = content.replace('{{sender.manager_name}}', '')
              }
            }

            while (content.includes('{{sender.manager_email}}')) {
              if (post.project.manager) {
                content = content.replace('{{sender.manager_email}}', post.project.manager.email)
              } else {
                content = content.replace('{{sender.manager_email}}', '')
              }
            }

            while (content.includes('{{sender.coordinator_name}}')) {
              if (post.project.coordinator) {
                content = content.replace('{{sender.coordinator_name}}', `${post.project.coordinator.first_name} ${post.project.coordinator.last_name}`)
              } else {
                content = content.replace('{{sender.coordinator_name}}', '')
              }
            }

            while (content.includes('{{sender.coordinator_email}}')) {
              if (post.project.coordinator) {
                content = content.replace('{{sender.coordinator_email}}', post.project.coordinator.email)
              } else {
                content = content.replace('{{sender.coordinator_email}}', '')
              }
            }

            return content
          }
